import { CompareMode } from "@/components/Impact/ImpactPill";
import useUrlStateNumber from "@/hooks/useUrlStateNumber";
import { useGetProductScenarios } from "@/pages/products/useProducts";
import { useEffect } from "react";
import styles from "./CompareProductScenarios.module.scss";
import ProductScenarioCompare from "./ProductScenarioCompare";

export default function CompareProductScenarios({
  productId,
  multiplier,
  displayMode,
}: {
  productId: number;
  multiplier?: number;
  displayMode: CompareMode;
}) {
  const [scenarioId1, setScenarioId1] = useUrlStateNumber("scenario_1_id");
  const [scenarioId2, setScenarioId2] = useUrlStateNumber("scenario_2_id");

  const productScenarios = useGetProductScenarios({ productId });

  useEffect(() => {
    if (scenarioId1 === undefined && scenarioId2 === undefined && productScenarios.data) {
      const numScenarios = productScenarios.data?.scenarios.length;
      if (numScenarios >= 2) {
        setScenarioId1(productScenarios.data?.scenarios[0].id || 0);
        setScenarioId2(productScenarios.data?.scenarios[1].id || 0);
      } else {
        setScenarioId1(productScenarios.data?.scenarios[0].id || 0);
        setScenarioId2(productScenarios.data?.scenarios[0].id || 0);
      }
    }
  }, [productScenarios.data]);

  return (
    <div className={styles.compare}>
      <div>
        <ProductScenarioCompare
          scenarioId={scenarioId1}
          compareScenarioId={scenarioId2}
          onScenarioChange={(scenarioId) => setScenarioId1(scenarioId)}
          productId={productId}
          multiplier={multiplier}
          displayMode={displayMode}
        />
      </div>
      <div>
        <ProductScenarioCompare
          scenarioId={scenarioId2}
          compareScenarioId={scenarioId1}
          onScenarioChange={(scenarioId) => setScenarioId2(scenarioId)}
          productId={productId}
          multiplier={multiplier}
          displayMode={displayMode}
        />
      </div>
    </div>
  );
}
